import type { FunctionalComponent } from 'preact';
import { IssueView } from '@/components/webzine/issue-view.tsx';
import { LoadingSpinner } from '@/components/loading-spinner.tsx';
import { useWebzineIssues } from '@/hooks/use-webzine.ts';
import type { PageProps } from '@/types/props.ts';

/**
 * 홈 — 웹진 최신 호 커버 (시안 `_index.html`).
 *
 * 화면 자체는 지난 호(`/webzine/:vol`)와 같은 레이아웃이라 `IssueView` 를 공유한다.
 * 내용은 `MC_WEBZINE` 에서 온다 — 노출중인 호 가운데 정렬값이 가장 큰 호다.
 */
const Home: FunctionalComponent<PageProps> = () => {
  const { issues, latest, loading, error } = useWebzineIssues();

  if (loading) return <LoadingSpinner show />;

  if (!latest) {
    return (
      <div class="page">
        <div class="section">
          <div class="contents" style={{ padding: '2rem 1.5rem' }}>
            <p>{error ?? '아직 발행된 웹진이 없습니다.'}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <IssueView
      issue={latest}
      backIssues={issues.filter((issue) => issue.slug !== latest.slug)}
      latestSlug={latest.slug}
      tabPath="/"
    />
  );
};

export default Home;
